import React, { useEffect, useState } from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";
import { connect } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import helpersNumbers from "../../../helpers/numbers";

function BrowsersCityPieChart({ browsersCities }) {
  const [data, setData] = useState([]);
  const [totalValue, setTotalValue] = useState(0);
  useEffect(() => {
    if (!browsersCities) {
      setData([]);
      return;
    }
    if (!Object.keys(browsersCities).length) {
      setData([]);
      return;
    }

    let dataPieChar = [];
    let index = 1;
    let totalCount = 0;

    let newBrowsersCities = {};
    for (let key in browsersCities) {
      const browsersCity = browsersCities[key];

      if (!newBrowsersCities.hasOwnProperty(browsersCity.city)) {
        let browserCity = {};

        browserCity[browsersCity.city] = parseInt(browsersCity.count);
        newBrowsersCities = {
          ...browserCity,
          ...newBrowsersCities,
        };
        continue;
      }
      newBrowsersCities[browsersCity.city] =
        newBrowsersCities[browsersCity.city] + browsersCity.count;
    }

    for (let cityName in newBrowsersCities) {
      const count = newBrowsersCities[cityName];
      totalCount = totalCount + count;

      dataPieChar.push({
        ID: uuidv4(),
        name: cityName,
        value: parseInt(count),
        color: "#" + Math.floor(Math.random() * 16777215).toString(16),
        opacity: 1,
      });
      index++;
    }

    setData(dataPieChar);
    setTotalValue(totalCount);
  }, [browsersCities]);

  const customizedTooltip = ({ payload, active }) => {
    if (!active) {
      return <></>;
    }
    if (payload == undefined) {
      return <></>;
    }

    if (payload[0] == undefined) {
      return <></>;
    }

    let label = payload[0].name;
    const partCircleHoverBackgroundColor = payload[0].payload.fill;
    return (
      <div className="card" id="box-details-pie-chart" dir="rtl">
        <div className="card-body p-3">
          <div className="text-center">{label}</div>
          <div className="my-2 hr-bottom-label"></div>
          <div className="d-flex pb-3">
            <span className="px-2">
              <i
                className="fa fa-circle"
                style={{ color: partCircleHoverBackgroundColor }}
              ></i>
            </span>
            <span className="pl-2">تعداد نمایش : </span>
            <span>{helpersNumbers.toPersianNum(payload[0].value)}</span>
          </div>
          <div className="d-flex  ">
            <span className="px-2">
              <i
                className="fa fa-circle"
                style={{ color: partCircleHoverBackgroundColor }}
              ></i>
            </span>
            <span className="pl-2">درصد : </span>
            <span>
              {helpersNumbers.toPersianNum(
                Math.floor((payload[0].value / totalValue) * 1000) / 10
              )}
              %
            </span>
          </div>
        </div>
      </div>
    );
  };

  const changeBgColorCellExpectCurrentCell = (currentCellID, changeOpacity) => {
    setData((prevState) => {
      return prevState.map((item) => {
        if (item.ID != currentCellID) {
          item.opacity = changeOpacity(item.opacity);
        }
        return item;
      });
    });
  };

  const mouseEnterHandle = (e, currentCellID) => {
    changeBgColorCellExpectCurrentCell(
      currentCellID,
      (opacity) => (opacity /= 2)
    );
  };
  const showPieChart = () => {
    return (
      <div style={{ margin: "0 auto" }}>
        <p className="text-center p-0">شهر</p>
        <ResponsiveContainer width={250} height={250}>
          <PieChart>
            <Pie
              data={data}
              labelLine={false}
              outerRadius={120}
              dataKey="value"
            >
              {data.map((entry, index) => {
                return (
                  <Cell
                    onMouseEnter={(e) => {
                      mouseEnterHandle(e, entry.ID);
                    }}
                    onMouseLeave={(e) => {
                      setData((prevState) => {
                        return prevState.map((item) => {
                          item.opacity = 1;
                          return item;
                        });
                      });
                    }}
                    style={{ opacity: entry.opacity }}
                    key={`cell-${index}`}
                    cursor="pointer"
                    fill={entry.color}
                  />
                );
              })}
            </Pie>
            <Tooltip content={customizedTooltip} />
          </PieChart>
        </ResponsiveContainer>
      </div>
    );
  };

  return <>{data.length > 0 && showPieChart()}</>;
}

const mapStateToProps = (state) => {
  return {
    browsersCities: state.reportCampaign.browsers_cities,
  };
};
export default connect(mapStateToProps, null)(BrowsersCityPieChart);
